import React from "react";
import { Link } from "react-router-dom";

const TopUsersList = ({ topUserStatData }) => (
  <div className="p-4 shadow rounded-4">
    <div className="d-flex justify-content-between mb-4 border-bottom pb-3">
      <strong>Top users</strong>
      <span className="text-muted">
        <i className="bi bi-three-dots-vertical"></i>
      </span>
    </div>
    {topUserStatData && topUserStatData.length > 0 ? (
      <ul className="list-unstyled w-full">
        {topUserStatData.map((userStat, index) => (
          <li
            className="mb-2 d-flex justify-content-start align-items-center w-full"
            key={index}
          >
            <div className="avatar">
              {userStat.creator.avatar ? (
                <img
                  className="rounded-circle"
                  src={`https://media.magipik.com/${userStat.creator.avatar}`}
                  width={32}
                  alt={`${userStat.creator.username || 'User'} avatar`}
                />
              ) : (
                <div
                  className="d-flex border mx-auto align-items-center justify-content-center rounded-circle bg-light text-secondary p-2"
                  style={{ width: 32, height: 32 }}
                >
                  <i className="bi bi-person-fill"></i>
                </div>
              )}
            </div>
            <div className="align-items-center ms-4">
              <p className="mb-1 small">
                <Link to={`/users/view/${userStat.creator._id}`}>
                  {userStat.creator.username}
                </Link>
              </p>
              <p className="small mb-0">
                <span className="text-muted me-3">
                  <i className="bi bi-file-arrow-up me-1"></i>
                  <span className="small">{userStat.totalUpload}</span>
                </span>
                <span className="text-muted me-3">
                  <i className="bi bi-eye me-1"></i>
                  <span className="small">{userStat.totalView}</span>
                </span>
                <span className="text-muted me-4">
                  <i className="bi bi-heart me-1"></i>
                  <span className="small">{userStat.totalLike}</span>
                </span>
              </p>
            </div>
          </li>
        ))}
      </ul>
    ) : (
      <p className="text-muted small">No top users data available.</p>
    )}
  </div>
);

export default TopUsersList;
